import loadable from "@loadable/component";
import useSlotConfig from "client/context/SlotConfig";
import React from "react";

export interface ModalsProps {}

const Modal = loadable(() => import(/* webpackChunkName: "Modal" */ "./Modal"), { resolveComponent: (m) => m.Modal });

export const Modals: React.FC<ModalsProps> = () => {
  const { modals } = useSlotConfig();

  if (!modals?.length) return null;
  return (
    <>
      {modals
        .filter((m) => m)
        .map((modal) => (
          <Modal key={modal._meta.deliveryId} config={modal} />
        ))}
    </>
  );
};
